<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3 w-crud-form">
      <template>
        <v-row>
          <v-col>
            <v-combobox
              v-model="filters.category_gasto_id"
              :items="category_gastos"
              outlined
              :item-text="customText"
              label="Categoria Gastos"
              hide-details="auto"
              clearable
              @change="handleChangeCategoryGasto"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row v-if="type == 3">
          <v-col>
            <v-autocomplete
              v-model="filters.worker_id"
              :items="all_workers"
              label="Trabajador"
              outlined
              :item-text="searchWorker"
              item-value="id"
              clearable
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row v-if="type == 1">
          <v-col>
            <v-combobox
              v-model="filters.type_document"
              :items="type_documents"
              outlined
              label="Tipo de Documento"
              hide-details="auto"
              clearable
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="filters.document"
              label="Número de documento"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters.date_from"
                  label="Desde"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date_from"
                @input="menuFrom = false"
                no-title
                locale="es"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuUntil"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters.date_until"
                  label="Hasta"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date_until"
                @input="menuUntil = false"
                no-title
                locale="es"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              height="40"
              dark
              color="red"
              @click="handleClearFilters"
            >
              <v-icon size="16" class="mr-1">far fa-trash-alt</v-icon>
              Quitar filtros
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="blue" block height="40" @click="handleSearch">
              <v-icon size="16" class="mr-1">fas fa-search</v-icon>
              Filtrar datos
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Filters",
  data() {
    return {
      drawer: false,
      titleForm: null,
      fields_show_all: true,
      fields_show: [],
      menuFrom: false,
      menuUntil: false,
      filters: {
        type_document: null,
        date_from: this.$moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        date_until: this.$moment().format("YYYY-MM-DD"),
        category_gasto_id: null,
        worker_id: null,
        document: null,
      },
      type_documents: ["BOLETA", "FACTURA"],
      type: 0,
    };
  },
  computed: {
    ...mapState("employees", ["all_workers"]),
    ...mapState("authentication", ["office_id"]),
    ...mapState("category-gasto", ["category_gastos"]),
  },
  methods: {
    ...mapActions("gasto", ["getGastos"]),
    showForm(title) {
      this.filters.office_id = this.office_id;
      this.titleForm = title;
      this.drawer = !this.drawer;
    },
    searchWorker(item) {
      return item.fullname;
    },
    closeForm() {
      this.drawer = false;
    },
    clearData() {
      this.filters.type_document = null;
      this.filters.date_from = this.$moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.filters.date_until = this.$moment().format("YYYY-MM-DD");
      this.filters.category_gasto_id = null;
      this.filters.worker_id = null;
      this.filters.document = null;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    async handleClearFilters() {
      this.clearData();
      await this.getGastos(this.filters);
    },
    async handleSearch() {
      await this.getGastos({
        ...this.filters,
        category_gasto_id: this.filters.category_gasto_id
          ? this.filters.category_gasto_id.id
          : null,
      });
      this.closeForm();
    },
    handleChangeCategoryGasto() {
      if (this.filters.category_gasto_id) {
        this.type = this.filters.category_gasto_id.type;
      } else {
        this.type = 0;
      }
    },
  },
};
</script>

<style scoped></style>
